import { TFunction } from "i18next"
import { Column } from "primereact/column"
import { ColumnGroup } from "primereact/columngroup"

export const SUMAS_SALDOS_COLUMNS_GROUP = (t: TFunction) => (
  <ColumnGroup>
    <tr>
      <Column
        header=''
        colSpan={2}
      />
      <Column
        headerClassName='[&_.p-column-title]:tw-mx-auto'
        header='Sumas'
        colSpan={2}
      />
      <Column
        headerClassName='[&_.p-column-title]:tw-mx-auto'
        header='Saldos'
        colSpan={2}
      />
      <Column
        header=''
        colSpan={1}
      />
    </tr>
    <tr>
      <Column
        header={t("informes.saldos.tab.headerAccount")}
        field='cuenta'
      />
      <Column
        header={t("informes.saldos.tab.headerName")}
        field='nombre'
      />
      <Column
        headerClassName='[&_.p-column-title]:tw-ml-auto !tw-border-0 !tw-border-l !tw-border-solid !tw-border-gray-100'
        header={t("informes.saldos.tab.headerDebit")}
        field='periodo.debe'
      />
      <Column
        headerClassName='[&_.p-column-title]:tw-ml-auto !tw-border-0 !tw-border-r !tw-border-solid !tw-border-gray-100'
        header={t("informes.saldos.tab.headerCredit")}
        field='periodo.haber'
      />
      <Column
        headerClassName='[&_.p-column-title]:tw-ml-auto'
        header={t("informes.saldos.tab.headerDebtor")}
        field='periodo.deudor'
      />
      <Column
        headerClassName='[&_.p-column-title]:tw-ml-auto !tw-border-0 !tw-border-r !tw-border-solid !tw-border-gray-100'
        header={t("informes.saldos.tab.headerCreditor")}
        field='periodo.acreedor'
      />
      <Column
        headerClassName='[&_.p-column-title]:tw-ml-auto'
        header={t("informes.saldos.tab.headerBalance")}
        field='periodo.saldo'
      />
    </tr>
  </ColumnGroup>
)
